export const actionTypes = {
  SET_PRODUCT_MODEL_LIST: "SET_PRODUCT_MODEL_LIST",
  SET_OPERATION_LOG_LIST: "SET_OPERATION_LOG_LIST",
  SET_OPERATION_LOG_TYPE_LIST: "SET_OPERATION_LOG_TYPE_LIST",
  SET_QA_CONTENT: "SET_QA_CONTENT",
  SET_CONTACT_CONTENT: "SET_CONTACT_CONTENT",
  SET_LOGO_FILE: "SET_LOGO_FILE",
  SET_SETTING_LIST: "SET_SETTING_LIST",
  SET_SETTING_AUTH_LIST: 'SET_SETTING_AUTH_LIST',
  SET_MODEL_LIST: 'SET_MODEL_LIST',
  SET_PUBLIC_FILE_LIST: "SET_PUBLIC_FILE_LIST",
  SET_SYSTEM_VERSION_LIST: "SET_SYSTEM_VERSION_LIST",
};